import styled from "styled-components";

export const QuizVideo = styled.img`
  width: calc(100% - 60px);
  margin: 20px;
`